import React, { useState } from 'react';

import { styled } from '@mui/material/styles';

import _ from 'lodash';

import { Paper, BottomNavigation, BottomNavigationAction } from '@mui/material';

import FilterListIcon from '@mui/icons-material/FilterList';
import ListIcon from '@mui/icons-material/List';
import FeedIcon from '@mui/icons-material/Feed';

const PREFIX = 'MobileBottomNavigation';

const classes = {
    paper: `${PREFIX}-paper`,
    new_lesson: `${PREFIX}-new_lesson`,
    filter_button: `${PREFIX}-filter_button`,
    new_lesson_button: `${PREFIX}-new_lesson_button`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.paper}`]: {
        minWidth: '28vw',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        overflowX: 'hidden',
    },

    [`& .${classes.new_lesson}`]: {
        padding: '0.5rem',
        display: 'flex'
    },

    [`& .${classes.filter_button}`]: {
        backgroundColor: '#0B7CB0',
        color: 'white',
        minWidth: '20vw',
        height: '2.5rem',
        padding: '0.5rem',
        minWidth: '5vw',
        margin: 'auto',
    },

    [`& .${classes.new_lesson_button}`]: {
        backgroundColor: '#0B7CB0',
        color: 'white',
        minWidth: '20vw',
        height: '2.5rem',
        // justifyContent: "flex-start"
    }
}));

const MobileBottomNavigation = props => {
    let { mobile_display_tab, updateMobileDisplayTab } = props;

    const [value, setValue] = React.useState(mobile_display_tab);

    return (
        <Root>
            <Paper elevation={7}
                // style={{backgroundColor: '#093d61'}}
            >
                <BottomNavigation
                showLabels
                value={mobile_display_tab}
                onChange={(event, newValue) => {
                    updateMobileDisplayTab(newValue);
                }}
                style={{position: 'fixed', bottom: 0, left: 0, right: 0}}
                >
                    <BottomNavigationAction label="Activities" icon={<FilterListIcon />} />
                    <BottomNavigationAction label="Lessons List" icon={<ListIcon />} />
                    <BottomNavigationAction label="Lesson Details" icon={<FeedIcon />} />
                </BottomNavigation>
            </Paper>
        </Root>
    );

}


export default MobileBottomNavigation;